import { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Grid as MuiGrid,
  OutlinedInput as MuiOutlinedInput,
  Container as MuiContainer,
  Typography as MuiTypography,
  Button as MuiButton,
  Paper as MuiPaper,
  Tabs as MuiTabs,
  Tab as MuiTab,
  IconButton as MuiIconButton,
  FormControl as MuiFormControl,
  Snackbar as MuiSnackbar,
  InputAdornment as MuiInputAdornment,
  CircularProgress as MuiCircularProgress,
} from "@material-ui/core";
import {
  Visibility as MuiVisibilityIcon,
  VisibilityOff as MuiVisibilityOffIcon,
} from "@material-ui/icons";
import { requestAuth } from "../../utils/apiRequests";
import { useUserState } from "../../hooks";

import services from "../../services";

import "./styles.css";

export default function SignInPage() {
  const { userState, setUserState } = useUserState();
  const history = useHistory();
  const [tabState, setTabState] = useState(0);
  const [formState, setFormState] = useState(["", ""]);
  const [passwordVisibility, setPasswordVisibility] = useState(false);

  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
    handleClose: function () {
      setSnackbarState({
        ...snackbarState,
        open: false,
        message: "",
        severity: "",
      });
    },
    handleOpen: function (message, severity) {
      setSnackbarState({
        ...snackbarState,
        open: true,
        message: message,
        severity: severity,
      });
    },
  });

  const [submitProgress, setSubmitProgress] = useState(false);

  return (
    <MuiGrid
      container={true}
      direction={"column"}
      alignContent={"center"}
      justify={"center"}
      className={"Signin position-absolute w-100 h-100"}
    >
      <div className={"position-absolute w-100 h-100 div1"}></div>
      <MuiContainer
        className={"MuiContainer1"}
        maxWidth={"xs"}
        disableGutters={true}
      >
        <MuiPaper className={"py-3"}>
          <MuiGrid
            className={"py-4"}
            container={true}
            direction={"column"}
            alignContent={"center"}
          >
            <MuiTypography align={"center"} gutterBottom={true} variant={"h4"}>
              {"Welcome Back!"}
            </MuiTypography>
            <MuiTabs
              value={tabState}
              centered={true}
              onChange={(event, newValue) => {
                setTabState(newValue);
                setFormState(["", ""]);
              }}
            >
              <MuiTab label={"Student"} />
              <MuiTab label={"Teacher"} />
            </MuiTabs>
            {tabState === 0 && (
              <MuiOutlinedInput
                className={"my-2"}
                size={"small"}
                value={formState[0]}
                placeholder={"Reg ID"}
                type={"text"}
                variant={"outlined"}
                onChange={(e) => {
                  let state = formState;
                  state[0] = e.target.value;
                  setFormState([...state]);
                }}
              />
            )}
            {tabState === 1 && (
              <MuiOutlinedInput
                className={"my-2"}
                value={formState[0]}
                placeholder={"Email Address"}
                type={"text"}
                onChange={(e) => {
                  let state = formState;
                  state[0] = e.target.value;
                  setFormState([...state]);
                }}
              />
            )}
            <MuiFormControl>
              <MuiOutlinedInput
                className={"my-2"}
                placeholder={"Password"}
                value={formState[1]}
                type={passwordVisibility ? "text" : "password"}
                onChange={(e) => {
                  let state = formState;
                  state[1] = e.target.value;
                  setFormState([...state]);
                }}
                endAdornment={
                  <MuiInputAdornment position="end">
                    <MuiIconButton
                      aria-label="toggle password visibility"
                      onClick={() => {
                        setPasswordVisibility(!passwordVisibility);
                      }}
                    >
                      {passwordVisibility ? (
                        <MuiVisibilityOffIcon />
                      ) : (
                        <MuiVisibilityIcon />
                      )}
                    </MuiIconButton>
                  </MuiInputAdornment>
                }
              />
            </MuiFormControl>

            <MuiButton
              className={"my-2"}
              color={"primary"}
              variant={"contained"}
              disabled={formState[0] === "" || formState[1] === ""}
              onClick={() => {
                setSubmitProgress(true);
                if (tabState === 0) {
                  services.api.auth.signIn
                    .student({ id: formState[0], password: formState[1] })
                    .then((data) => {
                      alert(data.message);
                      setUserState({
                        ...data.data.student,
                        accessToken: data.data.accessToken,
                      });
                      sessionStorage.setItem(
                        "access-token",
                        data.data.accessToken
                      );
                      localStorage.setItem("student", data.data.student._id);
                      history.push("/student/dashboard/overview");
                    })
                    .catch((error) => {
                      alert(error.message);
                      setSubmitProgress(false);
                    });
                }
                if (tabState === 1) {
                  services.api.auth.signIn
                    .teacher({
                      emailAddress: formState[0],
                      password: formState[1],
                    })
                    .then((data) => {
                      alert(data.message);
                      setUserState({
                        ...data.data.teacher,
                        accessToken: data.data.accessToken,
                      });
                      sessionStorage.setItem(
                        "access-token",
                        data.data.accessToken
                      );
                      localStorage.setItem("teacher", data.data.teacher._id);
                      history.push("/teacher/dashboard/overview");
                    })
                    .catch((error) => {
                      alert(error.message);
                      setSubmitProgress(false);
                    });
                }
              }}
            >
              {submitProgress ? (
                <MuiCircularProgress size={24} color="secondary" />
              ) : (
                <p>{"Sign In"}</p>
              )}
            </MuiButton>
          </MuiGrid>
        </MuiPaper>
      </MuiContainer>
    </MuiGrid>
  );
}
